import React, { Component } from 'react'
import { Button, Dimmer, Form, Header, Loader, Segment } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import AuthenticationStore from '../stores/AuthenticationStore'
import LoadingWrapper from '../components/LoadingWrapper'
import ModalError from '../components/ModalError'
import Toast from '../components/Toast'
import Input from '../components/Forms/Input'

@observer
class ProfileScreen extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore)
  }

  constructor (props) {
    super(props)
    this.props.authenticationStore.cloneProfile()
  }

  handleSaveUser = () => {
    const { authenticationStore } = this.props
    authenticationStore.saveProfile().then(() => {

    })
  }

  componentWillUnmount () {
    const { authenticationStore } = this.props
    authenticationStore.clearProfile()
  }

  render () {
    const { authenticationStore } = this.props
    const { isLoading, isSaving, toasts } = authenticationStore

    if (isLoading) {
      return (
        <Dimmer page active={isLoading}>
          <Loader />
        </Dimmer>
      )
    }
    return (
      <Segment basic>
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <ModalError store={authenticationStore} />
        <Toast toasts={toasts} />
        <Header as='h1'>Modifier votre profil</Header>
        <Form>
          <Input label='Prénom' name='user.first_name' store={authenticationStore} />
          <Input label='Nom' name='user.last_name' store={authenticationStore} />
          <Input label='Courriel' name='user.email' store={authenticationStore} />
          <Form.Field>
            <Input
              name='user.password' store={authenticationStore} label='Mot de passe' type='password'
              placeholder='Laisser vide pour ne pas modifier'
            />
          </Form.Field>
          <Button primary onClick={this.handleSaveUser}>Enregistrer</Button>
        </Form>
      </Segment>
    )
  }
}

export default ProfileScreen
